module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-280.1f54a48e.jpg";